/* Illustrations vectorielles "flat design" faites main en SVG/JSX — aucune image externe. */

export function HeroIllustration(props) {
  return (
    <svg viewBox="0 0 560 440" className={props.className} aria-hidden="true">
      <defs>
        <linearGradient id="heroSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#EEF2FF" />
          <stop offset="100%" stopColor="#FDF4E9" />
        </linearGradient>
        <linearGradient id="heroLaptop" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4F46E5" />
          <stop offset="100%" stopColor="#7C6CF6" />
        </linearGradient>
      </defs>

      <ellipse cx="280" cy="400" rx="220" ry="24" fill="#E7E4FB" />
      <circle cx="280" cy="200" r="190" fill="url(#heroSky)" />

      {/* nuage de connexion */}
      <g className="anim-float-slow">
        <circle cx="90" cy="90" r="10" fill="#FFC857" />
        <circle cx="480" cy="70" r="14" fill="#FF7A59" opacity="0.85" />
        <circle cx="500" cy="140" r="7" fill="#22C55E" />
      </g>

      {/* Personnage assis */}
      <g className="anim-float">
        {/* chaise / bureau */}
        <rect x="150" y="300" width="260" height="18" rx="9" fill="#D6D3FA" />
        <rect x="170" y="318" width="16" height="55" rx="6" fill="#C4C0F2" />
        <rect x="374" y="318" width="16" height="55" rx="6" fill="#C4C0F2" />

        {/* laptop */}
        <g transform="translate(210,230)">
          <rect x="0" y="40" width="140" height="10" rx="4" fill="#B9B4EE" />
          <rect x="10" y="-40" width="120" height="82" rx="10" fill="url(#heroLaptop)" />
          <rect x="20" y="-30" width="100" height="62" rx="4" fill="#EEF2FF" />
          <rect x="34" y="-16" width="72" height="8" rx="4" fill="#4F46E5" opacity="0.35" />
          <rect x="34" y="-2" width="50" height="8" rx="4" fill="#FF7A59" opacity="0.6" />
          <rect x="34" y="12" width="60" height="8" rx="4" fill="#22C55E" opacity="0.6" />
        </g>

        {/* corps */}
        <g transform="translate(215,150)">
          <circle cx="65" cy="20" r="30" fill="#FFD9B3" />
          <path d="M35 20a30 30 0 0 1 60 0v6H35z" fill="#2B2350" />
          <rect x="30" y="48" width="70" height="90" rx="26" fill="#4F46E5" />
          <rect x="20" y="70" width="26" height="70" rx="13" fill="#4F46E5" />
          <rect x="94" y="70" width="26" height="70" rx="13" fill="#FF7A59" />
          <circle cx="33" cy="140" r="10" fill="#FFD9B3" />
          <circle cx="107" cy="140" r="10" fill="#FFD9B3" />
        </g>
      </g>

      {/* bulle de chat flottante */}
      <g className="anim-float-fast" transform="translate(60,220)">
        <rect x="0" y="0" width="86" height="54" rx="16" fill="#FFFFFF" stroke="#EDEBFB" strokeWidth="2" />
        <path d="M14 54 L14 66 L30 54 Z" fill="#FFFFFF" />
        <circle cx="20" cy="27" r="6" fill="#4F46E5" />
        <circle cx="43" cy="27" r="6" fill="#FF7A59" />
        <circle cx="66" cy="27" r="6" fill="#FFC857" />
      </g>

      {/* trophée challenge */}
      <g className="anim-float" transform="translate(420,240)">
        <circle r="34" fill="#FFF7E6" />
        <path d="M-10 -12h20v14a10 10 0 0 1-20 0z" fill="#FFC857" />
        <rect x="-4" y="6" width="8" height="8" fill="#FFC857" />
        <rect x="-12" y="14" width="24" height="6" rx="3" fill="#E9A93B" />
        <path d="M-10 -8c-8 0-8 14 0 14" stroke="#E9A93B" strokeWidth="3" fill="none" />
        <path d="M10 -8c8 0 8 14 0 14" stroke="#E9A93B" strokeWidth="3" fill="none" />
      </g>
    </svg>
  )
}

export function CollabIllustration(props) {
  return (
    <svg viewBox="0 0 200 160" className={props.className} aria-hidden="true">
      <circle cx="100" cy="80" r="76" fill="#EEF2FF" />
      <circle cx="66" cy="70" r="20" fill="#FFD9B3" />
      <rect x="40" y="92" width="52" height="46" rx="18" fill="#4F46E5" />
      <circle cx="134" cy="70" r="20" fill="#F4B183" />
      <rect x="108" y="92" width="52" height="46" rx="18" fill="#FF7A59" />
      <rect x="70" y="60" width="60" height="40" rx="10" fill="#FFFFFF" stroke="#DAD6FA" strokeWidth="2" />
      <rect x="80" y="70" width="40" height="6" rx="3" fill="#4F46E5" opacity="0.4" />
      <rect x="80" y="82" width="26" height="6" rx="3" fill="#22C55E" opacity="0.6" />
    </svg>
  )
}

export function ChatIllustration(props) {
  return (
    <svg viewBox="0 0 200 160" className={props.className} aria-hidden="true">
      <circle cx="100" cy="80" r="76" fill="#FFF3EA" />
      <rect x="36" y="40" width="90" height="60" rx="18" fill="#4F46E5" />
      <path d="M50 100 L50 116 L70 100 Z" fill="#4F46E5" />
      <circle cx="58" cy="70" r="6" fill="#fff" />
      <circle cx="80" cy="70" r="6" fill="#fff" />
      <circle cx="102" cy="70" r="6" fill="#fff" />
      <rect x="86" y="72" width="78" height="52" rx="16" fill="#FF7A59" />
      <path d="M150 124 L150 138 L132 124 Z" fill="#FF7A59" />
      <circle cx="104" cy="98" r="5" fill="#fff" />
      <circle cx="120" cy="98" r="5" fill="#fff" />
      <circle cx="136" cy="98" r="5" fill="#fff" />
    </svg>
  )
}

export function QuizIllustration(props) {
  return (
    <svg viewBox="0 0 200 160" className={props.className} aria-hidden="true">
      <circle cx="100" cy="80" r="76" fill="#EEFBF1" />
      <rect x="55" y="34" width="90" height="100" rx="14" fill="#FFFFFF" stroke="#DDF3E1" strokeWidth="2" />
      <circle cx="76" cy="58" r="10" fill="#22C55E" />
      <path d="M71 58l4 4 8-8" stroke="#fff" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="94" y="52" width="42" height="8" rx="4" fill="#123" opacity="0.08" />
      <circle cx="76" cy="86" r="10" fill="#FFC857" />
      <rect x="94" y="80" width="34" height="8" rx="4" fill="#123" opacity="0.08" />
      <circle cx="76" cy="114" r="10" fill="#FF7A59" />
      <rect x="94" y="108" width="38" height="8" rx="4" fill="#123" opacity="0.08" />
      <g className="anim-float-fast">
        <circle cx="150" cy="40" r="16" fill="#FFC857" />
        <path d="M144 40l4 4 8-8" stroke="#fff" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}

export function ExamIllustration(props) {
  return (
    <svg viewBox="0 0 200 160" className={props.className} aria-hidden="true">
      <circle cx="100" cy="80" r="76" fill="#F1F0FE" />
      <rect x="58" y="30" width="84" height="106" rx="12" fill="#4F46E5" />
      <rect x="70" y="46" width="60" height="8" rx="4" fill="#fff" opacity="0.85" />
      <rect x="70" y="62" width="60" height="6" rx="3" fill="#fff" opacity="0.5" />
      <rect x="70" y="74" width="44" height="6" rx="3" fill="#fff" opacity="0.5" />
      <rect x="70" y="94" width="60" height="6" rx="3" fill="#fff" opacity="0.5" />
      <rect x="70" y="106" width="36" height="6" rx="3" fill="#fff" opacity="0.5" />
      <circle cx="140" cy="120" r="26" fill="#FFC857" />
      <path d="M129 120l7 7 15-15" stroke="#8A5B00" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function RuralUrbanIllustration(props) {
  return (
    <svg viewBox="0 0 560 200" className={props.className} aria-hidden="true">
      <rect x="0" y="150" width="560" height="6" fill="#E7E4FB" />
      {/* maison rurale */}
      <g transform="translate(60,90)">
        <polygon points="0,40 40,0 80,40" fill="#FF7A59" />
        <rect x="10" y="40" width="60" height="50" fill="#FFE7DC" />
        <rect x="32" y="60" width="16" height="30" fill="#4F46E5" />
        <circle cx="100" cy="30" r="14" fill="#8DD6A3" />
        <rect x="96" y="30" width="8" height="40" fill="#B08858" />
      </g>
      {/* antenne solaire / connexion */}
      <g className="anim-float-fast" transform="translate(150,40)">
        <rect x="-3" y="0" width="6" height="40" fill="#B9B4EE" />
        <circle r="10" fill="#FFC857" />
      </g>
      {/* immeubles urbains */}
      <g transform="translate(330,50)">
        <rect x="0" y="30" width="46" height="90" fill="#7C6CF6" />
        <rect x="56" y="10" width="46" height="110" fill="#4F46E5" />
        <rect x="112" y="46" width="40" height="74" fill="#9C91F8" />
        {Array.from({ length: 6 }).map((_, i) => (
          <rect key={i} x={8 + (i % 3) * 12} y={44 + Math.floor(i / 3) * 20} width="8" height="10" fill="#FFF3D6" />
        ))}
        {Array.from({ length: 8 }).map((_, i) => (
          <rect key={i} x={64 + (i % 3) * 12} y={24 + Math.floor(i / 3) * 20} width="8" height="10" fill="#FFF3D6" />
        ))}
      </g>
      {/* fil de connexion reliant les deux */}
      <path d="M150 70 C 240 -10, 300 -10, 340 60" stroke="#C4C0F2" strokeWidth="3" strokeDasharray="6 8" fill="none" />
    </svg>
  )
}
